import mod from "-!./Order.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./Order.js?vue&type=script&lang=js&external"